<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
	<h1 class="text-black title-6 md:title-3">Reportes</h1>
		<div class="flex flex-col flex-wrap justify-center flex-1 py-16 md:justify-start sm:flex-row lg:grid-cols-3 md:flex-0 flex-zafari">
			<button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
                routerLink="formulario"
			>
				
            <mat-icon
            class="w-[53.33px] h-[53.33px] min-w-[53.33px] min-h-[53.33px] text-primary-gray-01"
            svgIcon="icons:lapiz-icon"
        ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Formulario 24</p>
			</button>

			<button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
                routerLink="libro"
			>
            <mat-icon
            class="w-[44px] h-[56px] min-w-[44px] min-h-[56px] text-primary-gray-01"
            svgIcon="icons:pagares-icon"
        ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Libro de pagarés</p>
			</button>

            <button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
				routerLink="reporte-pagares"
			>
            <mat-icon
            class="w-[48px] h-[48px] min-w-[48px] min-h-[48px] text-primary-gray-01"
            svgIcon="icons:reportes-icon"
        ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Reporte de pagarés</p>
			</button>

            <button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
				routerLink="reporte-folios"
			>
            <mat-icon
            class="w-[44px] h-[56px] min-w-[44px] min-h-[56px] text-primary-gray-01"
            svgIcon="icons:pagares-icon"
        ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Reporte de folios</p>
			</button>
		</div>
</main>
